// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__UQ5Uf","productName":"Table_productName__1aa7B"};